import { useEffect, type ReactNode } from 'react';
import { useAuthStore } from '@store/authStore';
import { authService } from '@services/authService';
import { registerUnauthorizedHandler, tokenStorage } from '@services/api';

export function AuthProvider({ children }: { children: ReactNode }) {
  const setUser = useAuthStore((s) => s.setUser);

  useEffect(() => {
    registerUnauthorizedHandler(() => {
      tokenStorage.clear();
      setUser(null);
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    });
  }, [setUser]);

  useEffect(() => {
    const token = tokenStorage.getAccessToken();
    if (!token) return;
    // hydrate current user from token
    authService
      .me()
      .then(setUser)
      .catch(() => {
        tokenStorage.clear();
        setUser(null);
      });
  }, [setUser]);

  return <>{children}</>;
}
